export default __webpack_public_path__ + "static/media/vo_en.90c9d989.m4a";